import "./detail_page.css";

//●◈◙◎◉•

function DetailPage() {
  const physical_list: string = `✓ 세면도움, 구강관리, 머리감기
✓ 몸청결, 몸단장, 옷갈아입히기
✓ 목욕도움
✓ 식사도움 
    - 씹는 기능 또는 소화기능에 따라 미음, 죽식, 일반식
✓ 체위변경, 이동도움
    - 욕창위험대상의 경우 방문시마다 서비스 제공일지에 어르신의 상태 기록
✓ 신체기능의 유지․증진
    - 일상동작훈련(일어나기, 균형, 보행, 식사동작, 배설동작, 옷 갈아기동작, 가사동작 등)의 훈련
✓ 화장실이용하기, 대소변도움`;
  const housework_list: string = `✓ 취사도움
✓ 청소 및 주변정돈(세탁) 서비스`;
  const private_list: string = `✓ 외출시 동행
    - 병원 및 약처방 시 외출(출발, 행선지, 소요시간 기재)
    - 어르신의 요청에 따른 외출(시장, 목욕, 산책 등) 동행
✓ 일상업무 대행
    - 장보기, 심부름, 은행, 약처방 등의 어르신 스스로 할 수 없는 범위의 업무 요청시`;
  const emotion_list: string = `✓ 말벗, 격려 및 위로(뉴스, 사회현상 ,옛 이야기,종교관련)
✓ 생활상담(가계상담, 저축도움, 생활비 모니터링)
✓ 의사소통 도움`;
  const notice_list: string = `✓ 서비스의 대상은 대상자 본인이므로, 대상자 본인이 아닌 경우 서비스를 제공할 수 없습니다.
✓ 요양보호사의 의료 및 유사 의료행위는 법에 접촉되므로, 서비스를 제공할 수 없습니다.
✓ 예정된 서비스 제공 시간을 초과하여 서비스를 제공할 수 없습니다. (시간 외 심부름)`;

  return (
    <div className="detail_page">
      <div className="detail_container">
        <div className="support_container">
          <div className="support_title" id="physical">
            신체활동지원
          </div>
          <div className="support_list">{physical_list}</div>
        </div>
        <div className="support_container">
          <div className="support_title" id="housework">
            가사지원
          </div>
          <div className="support_list">{housework_list}</div>
        </div>
        <div className="support_container">
          <div className="support_title" id="private">
            개인활동지원
          </div>
          <div className="support_list">{private_list}</div>
        </div>
        <div className="support_container">
          <div className="support_title" id="emotion">
            정서지원(우애서비스)
          </div>
          <div className="support_list">{emotion_list}</div>
        </div>
        <div className="support_container">
          <div className="support_title" id="notice">
            유의사항
          </div>
          <div className="support_list">{notice_list}</div>
        </div>
      </div>
    </div>
  );
}

export default DetailPage;
